import Loader from "../../../loader";
import { useSelector } from "react-redux";

const SavedAs = ({ setIsModal,status,setSatus ,onSubmit}) => {
  
  const { isLoading } = useSelector((state) => state.coach.auth);

  

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div
      className="modal d-block modal-lg ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div className="modal-content ">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={() => {
                setIsModal(false);
              }}
            ></button>
          </div>
          <div className="modal-body px-0">
           

            <form className="mt-2  px-5 " >
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="d-block mb-2">Saved As</label>
                      <select
                        className="form-control ct_input  "
                        onChange={(e) => {
                          setSatus(e.target.value);
                        }}
                        value={status}
                      >
                        <option value={"Draft"}>Draft</option>
                        <option value={"Publish"}>Publish</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                <button
                  className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                  type="button"
                  onClick={onSubmit}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavedAs;
